import { serverCall } from "../modules/ServerComms";


function createCampaign(payload, theCallback, theJWTToken) {
  const API_URL = `/api/campaign/create`;
  serverCall(
    "POST",
    API_URL,
    payload,
    function (resStatus, resJson) {
      let responseString;
      if (resStatus == "200" || resStatus == 200) {
        if (resJson.message) {
          responseString = resJson.message;
        }
        return theCallback(resStatus, responseString, resJson);
      } else {
        return theCallback(resStatus, resJson.message, false);
      }
    },
    theJWTToken
  );
}

function updateCampaign(payload, theCallback, theJWTToken) {
  const API_URL = `/api/campaign/update`;
  serverCall(
    "PATCH",
    API_URL,
    payload,
    function (resStatus, resJson) {
      let responseString;
      if (resStatus == "200" || resStatus == 200) {
        if (resJson.message) {
          responseString = resJson.message;
        }
        return theCallback(resStatus, responseString, resJson);
      } else {
        return theCallback(resStatus, resJson.message, false);
      }
    },
    theJWTToken
  );
}

function bulkDeleteCampaigns(payload, theCallback, theJWTToken) {
  const API_URL = `/api/campaign/bulkDelete`;
  serverCall(
    "DELETE",
    API_URL,
    payload,
    function (resStatus, resJson) {
      let responseString;
      if (resStatus == "200" || resStatus == 200) {
        if (resJson.message) {
          responseString = resJson.message;
        }
        return theCallback(resStatus, responseString, resJson);
      } else {
        return theCallback(resStatus, resJson.message, false);
      }
    },
    theJWTToken
  );
}

function getCampaignCounts(theCallback, theJWTToken) {
  const API_URL = `/api/campaign/statusCount`;
  serverCall(
    "GET",
    API_URL,
    null,
    function (resStatus, resJson) {
      let responseString;
      if (resStatus == "200" || resStatus == 200) {
        if (resJson.message) {
          responseString = resJson.message;
        }
        return theCallback(resStatus, responseString, resJson);
      } else {
        return theCallback(resStatus, resJson.message, false);
      }
    },
    theJWTToken
  );
}

function getCampaignList(queryParams, theCallback, theJWTToken) {
  const params = new URLSearchParams();

  for (const key in queryParams) {
    if (
      queryParams.hasOwnProperty(key) &&
      queryParams[key] !== null &&
      queryParams[key] !== undefined &&
      queryParams[key] !== ""
    ) {
      params.append(key, queryParams[key]);
    }
  }

  const queryString = params.toString() ? `?${params.toString()}` : "";
  const API_URL = `/api/campaign/list${queryString}`;

  serverCall(
    "GET",
    API_URL,
    null,
    function (resStatus, resJson) {
      let responseString;
      if (resStatus == "200" || resStatus == 200) {
        if (resJson.message) {
          responseString = resJson.message;
        }
        return theCallback(resStatus, responseString, resJson);
      } else {
        return theCallback(resStatus, resJson.message, false);
      }
    },
    theJWTToken
  );
}

function linkCouponToCampaign(payload, theCallback, theJWTToken) {
  const API_URL = `/api/campaign/linkCoupon`;
  serverCall(
    "PATCH",
    API_URL,
    payload,
    function (resStatus, resJson) {
      let responseString;
      if (resStatus == "200" || resStatus == 200) {
        if (resJson.message) {
          responseString = resJson.message;
        }
        return theCallback(resStatus, responseString, resJson);
      } else {
        return theCallback(resStatus, resJson.message, false);
      }
    },
    theJWTToken
  );
}

function unlinkCouponFromCampaign(payload, theCallback, theJWTToken) {
  const API_URL = `/api/campaign/unlinkCoupon`;
  serverCall(
    "PATCH",
    API_URL,
    payload,
    function (resStatus, resJson) {
      let responseString;
      if (resStatus == "200" || resStatus == 200) {
        if (resJson.message) {
          responseString = resJson.message;
        }
        return theCallback(resStatus, responseString, resJson);
      } else {
        return theCallback(resStatus, resJson.message, false);
      }
    },
    theJWTToken
  );
}

function deleteCampaign(payload, theCallback, theJWTToken) {
  const API_URL = `/api/campaign/delete`;
  serverCall(
    "POST",
    API_URL,
    payload,
    function (resStatus, resJson) {
      let responseString;
      if (resStatus == "200" || resStatus == 200) {
        if (resJson.message) {
          responseString = resJson.message;
        }
        return theCallback(resStatus, responseString, resJson);
      } else {
        return theCallback(resStatus, resJson.message, false);
      }
    },
    theJWTToken
  );
}

export {
  createCampaign,
  updateCampaign,
  bulkDeleteCampaigns,
  getCampaignCounts,
  getCampaignList,
  linkCouponToCampaign,
  unlinkCouponFromCampaign,
  deleteCampaign,
};
